import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import Box from "@material-ui/core/Box";
import PropTypes from "prop-types";

import SubscriptionsGrid from "../Grid/SubscriptionsGrid.jsx";
import FilterComponent from "../FilterComponent/FilterComponent.jsx";
import NewFilter from "../NewFilter/NewFilter.jsx";

const Subscriptions = (props) => {
    const versionFilter = "subscriptions";

    const { mainId } = useParams();
    const location = useLocation();

    let resGrid = <Typography variant={"body1"}>Нет записей </Typography>;

    if (props.subscriptionsData.loading) {
        resGrid = <LinearProgress mt={4} />;
    } else if (
        !props.subscriptionsData.loading &&
        props.subscriptionsData?.AllItems?.length > 0
    ) {
        resGrid = (
            <SubscriptionsGrid
                editAction={props.editAction}
                resData={props.subscriptionsData}
                columns={props.columns}
                fields={props.fields}
                paramsChangeHandler={props.paramsChangeHandler}
                getParams={cleanParams(
                    props.globalSearch.search[versionFilter],
                )}
                globalSearch={props.globalSearch}
                updateGlobalSearch={props.updateGlobalSearch}
                versionFilter={versionFilter}
                roomTypesShort={props.roomTypesShort}
            />
        );
    }
    return (
        <Paper elevation={3}>
            <Box p={3}>
                <Typography mb={3} variant={"h5"}>
                    {props.title}
                </Typography>
            </Box>
            <FilterComponent
                pathname={location.pathname}
                initSearch={props.paramsChangeHandler}
                roomTypes={props.roomTypes}
                getParams={cleanParams(props.globalSearch.search.subscriptions)}
                globalSearch={props.globalSearch}
                updateGlobalSearch={props.updateGlobalSearch}
            />
            <Box mt={4}>{resGrid}</Box>
        </Paper>
    );
};

Subscriptions.defaultProps = {
    subscriptionsData: {
        AllItems: [],
        AuxItems: [],
        currentItem: null,
        error: null,
    },
    columns: [
        { id: "id", label: "id" },
        { id: "name_guest", label: "Гость" },
        { id: "created_at", label: "Дата создания" },
        { id: "date_in", label: "Дата заезда" },
        { id: "date_out", label: "Дата выезда" },
        { id: "email", label: "email гостя" },
        { id: "status", label: "Статус" },
        { id: "roomName", label: "Категория номера" },
        { id: "promo_code", label: "Промокод" },
    ],
};

export default Subscriptions;

const cleanParams = (obj) => {
    const newParams = {};
    for (const key in obj) {
        if (obj[key] !== "") {
            newParams[key] = obj[key];
        }
    }
    return newParams;
};
